React           = require 'react'
Xrespond        = require '../scripts/xrespond'
DeviceStore     = require '../scripts/device_store'
ToggleExpanded  = require '../mixins/toggle_expanded'
DropdownDevices = require '../components/dropdown_devices'

module.exports = DeviceAdd = React.createClass
  mixins: [ ToggleExpanded ]

  componentWillMount: ->
    document.addEventListener 'keydown', @handleEscKey, false

  componentWillUnmount: ->
    document.removeEventListener 'keydown', @handleEscKey, false

  getInitialState: ->
    expanded: false

  handleDropdownSubmit: (attrs) ->
    DeviceStore.create attrs
    @toggleExpanded()

  dropdown: ->
    React.createElement(DropdownDevices, { \
      "reset": (true),  \
      "key": (@props.id),  \
      "id": (@props.id),  \
      "devices": (Xrespond.devices_grouped()),  \
      "handleSubmit": (@handleDropdownSubmit),  \
      "handleBlur": (@toggleExpanded)
    })

  handleEscKey: (event) ->
    if @state.expanded && event.keyCode == 27 # Escape key
      @setState expanded: false
      @refs.dropdownButton.focus()

  render: ->
    React.createElement("article", {"className": "device"},
      React.createElement("div", {"className": "device__wrap"},
        React.createElement("div", {"className": "device-control"},
          React.createElement("div", {"className": "button-group"},
            React.createElement("button", {"className": "button button--medium button--secondary button-group__button device-control__button", "onClick": (@toggleExpanded), "ref": "dropdownButton"},
              React.createElement("div", {"className": "button__wrap"}, """
                Add new device
""", React.createElement("svg", {"className": "icon icon--medium button__icon"},
                  React.createElement("use", {"xlinkHref": "images/icons.svg#icon-arrow-drop-down"})
                )
              )
            )
          ),
          (if @state.expanded then @dropdown() else '')
        )
      )
    )



// WEBPACK FOOTER //
// ./~/cjsx-loader!./app/js/components/device_add.cjsx